import { render } from "./SimsList.vue?vue&type=template&id=ef81073c&scoped=true"
import script from "./SimsList.vue?vue&type=script&lang=js"
export * from "./SimsList.vue?vue&type=script&lang=js"

import "./SimsList.vue?vue&type=style&index=0&id=ef81073c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef81073c"]])

export default __exports__